module.exports = "images/miscellaneous_dot.7257cb9d30502ceec580cb056b5731e5.png";